import { render, staticRenderFns } from "./ImageTextCard.vue?vue&type=template&id=668511b8&scoped=true"
import script from "./ImageTextCard.vue?vue&type=script&lang=js"
export * from "./ImageTextCard.vue?vue&type=script&lang=js"
import style0 from "./ImageTextCard.vue?vue&type=style&index=0&id=668511b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668511b8",
  null
  
)

export default component.exports